import React from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext, ServicesContext } from '~/services';

export function useRoleActions(access, patient) {
    const { authenticated } = React.useContext(AuthContext);
    const context = React.useContext(ServicesContext);
    const { id } = useParams();

    return React.useMemo(() => {
        if (!access) return true;
        if (!authenticated) return false;
        let roles;
        if (context.user.isMACLUser()) {
            // If they're an MACL user, check their access that way
            const maclId = !patient?.macls?.[0]?.id
                ? context.patient.get(id)?.macls?.[0]?.id
                : patient.macls[0].id;
            if (!maclId) return false;
            roles = context.user.get().macl_users.find((x) => x.macl.id === maclId);
        } else if (context.user.isMarketUser()) {
            // And market users
            const marketId = !patient?.markets?.[0]?.id
                ? context.patient.get(id)?.markets?.[0]?.id
                : patient.markets[0].id;
            if (!marketId) return false;
            roles = context.user.get().market_users.find((x) => x.market.id === marketId);
        } else {
            // Finally org users
            // if no patient in props, get stored object via the url
            // We always use organization 0 for these checks, backend ensures
            // that permissions are ordered correctly in this array
            const patientOrgId = !patient?.organizations?.[0]?.id
                ? context.patient.get(id)?.organizations?.[0]?.id
                : patient.organizations[0].id;
            if (!patientOrgId) return false;
            roles = context.user
                .get()
                .organization_users.find((x) => x.organization.id === patientOrgId);
        }

        if (!roles?.access_policy) return false;
        return roles.access_policy[access];
    }, [access, authenticated, context.patient, context.user, id, patient]);
}
